const queryKeys = {
  DASHBOARDS: "dashboards",
  REPORTS: "reports",
  REPORTS_EXPORT: "reports export",
  SEND_REPORT_EMAIL: "report send email",
  ORGANIZATIONS: "organizations",
  ACCESSIBLE_ORGANIZATIONS: "accessible_organizations",
  LAST_ACCESS_ORGANIZATION: "last_access_organization"
};

export default queryKeys;
